import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icons/N.png';
const _withScopeId = n => (_pushScopeId("data-v-727d50c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left-sidebar",
  id: "left-sidebar"
};
const _hoisted_2 = {
  class: "left-menubar",
  id: "left-menubar"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "80px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "margin-top": "36px",
    "width": "53px",
    "height": "19px"
  },
  src: _imports_0
})], -1));
const _hoisted_4 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_5 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_6 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_7 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_8 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_9 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_10 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_11 = {
  class: "right-area",
  id: "right-area"
};
const _hoisted_12 = {
  class: "fixed-header"
};
const _hoisted_13 = {
  style: {
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "padding-left": "20px"
  }
};
const _hoisted_14 = {
  class: "header-title"
};
const _hoisted_15 = {
  style: {
    "position": "absolute"
  }
};
const _hoisted_16 = {
  class: "head-button-group"
};
const _hoisted_17 = {
  style: {
    "min-width": "30px",
    "margin-left": "17px",
    "color": "#777777",
    "font-size": "13.5px",
    "font-weight": "400"
  }
};
const _hoisted_18 = {
  class: "scrollable-content"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "modal-title",
  style: {
    "font-size": "12px"
  }
}, "更新说明", -1));
const _hoisted_20 = {
  class: "visionBox"
};
const _hoisted_21 = {
  class: "visionUl"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_a_tooltip = _resolveComponent("a-tooltip");
  const _component_a_menu_item = _resolveComponent("a-menu-item");
  const _component_a_menu = _resolveComponent("a-menu");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_avatar = _resolveComponent("a-avatar");
  const _component_a_badge = _resolveComponent("a-badge");
  const _component_a_dropdown = _resolveComponent("a-dropdown");
  const _component_router_view = _resolveComponent("router-view");
  const _component_vxe_button = _resolveComponent("vxe-button");
  const _component_a_divider = _resolveComponent("a-divider");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_a_menu, {
    openKeys: _ctx.state.openKeys,
    "onUpdate:openKeys": _cache[0] || (_cache[0] = $event => _ctx.state.openKeys = $event),
    selectedKeys: _ctx.state.selectedKeys,
    "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => _ctx.state.selectedKeys = $event),
    mode: "inline",
    theme: "light",
    "inline-collapsed": _ctx.state.collapsed,
    onClick: _ctx.menuSelect
  }, {
    default: _withCtx(() => [_ctx.permission.havePermission('活动管理', '活动详情') || _ctx.permission.havePermission('活动管理', '新建活动') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "1"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '1' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item1",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.activityTracking")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item1",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '1' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("home.activityTracking")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('互动数据', '查看互动数据') || _ctx.permission.havePermission('互动数据', '查看所有互动数据') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "2",
      class: "menuItemC"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '2' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item2",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.interactionData")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item2",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '2' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("home.interactionData")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('店铺管理', '查看店铺') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "5"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '5' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item5",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.storeManagement")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item5",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '5' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("home.storeManagement")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('屏幕管理', '查看') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "3"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '3' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item3",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.screenManagement")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item3",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '3' ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("home.screenManagement")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('数据信息', '查看数据信息') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "7"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '7' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item7",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode("数据信息")]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item7",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '7' ? (_openBlock(), _createElementBlock("span", _hoisted_8, "数据信息")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('报修', '报修查看') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "4"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '4' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item4",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.repairList")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item4",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '4' ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("home.repairList")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('用户管理', '查询用户') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "6"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '6' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item6",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.userManagement")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item6",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '6' ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("home.userManagement")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["openKeys", "selectedKeys", "inline-collapsed", "onClick"]), _createElementVNode("div", {
    class: "visionIcon",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.dialogVisible = true)
  }, "version." + _toDisplayString(_ctx.activeName), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
    id: "menu-button",
    style: {
      "width": "26px",
      "height": "26px",
      "border": "unset",
      "margin-right": "10px"
    },
    class: "button-circle",
    circle: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "Toggle",
      iconSize: "26px"
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.store.state.headerTitle), 1)])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_a_button, {
    onClick: _ctx.changeLanguage,
    class: "button-circle",
    style: {
      "margin-left": "30px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "enCn",
      iconSize: "20px"
    })]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_a_button, {
    class: "button-circle",
    style: {
      "margin-left": "14px",
      "margin-right": "15px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "bell",
      iconSize: "20px"
    })]),
    _: 1
  }), _createVNode(_component_a_dropdown, null, {
    overlay: _withCtx(() => [_createVNode(_component_a_menu, {
      onClick: _ctx.barCommand
    }, {
      default: _withCtx(() => [_createVNode(_component_a_menu_item, {
        key: "modify"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.editInfo")), 1)]),
        _: 1
      }), _createVNode(_component_a_menu_item, {
        key: "logout"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.logout")), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_a_badge, {
      dot: "",
      status: "success",
      offset: [-4, 16]
    }, {
      default: _withCtx(() => [_ctx.globalUser.avatar != null && _ctx.globalUser.avatar != '' ? (_openBlock(), _createBlock(_component_a_avatar, {
        key: 0,
        class: "touxiang",
        size: 40,
        src: _ctx.globalUser.avatar
      }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_a_avatar, {
        key: 1,
        class: "touxiang",
        size: 40,
        src: ''
      }))]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.globalUser.lastName) + " " + _toDisplayString(" ") + " " + _toDisplayString(_ctx.globalUser.firstName), 1)])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_router_view, {
    ref: "childComponent"
  }, null, 512), _ctx.buttonShow ? (_openBlock(), _createBlock(_component_vxe_button, {
    key: 0,
    onClick: _ctx.goBack,
    type: "text",
    class: "backNew"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "backNew",
      iconSize: "40px"
    })]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])]), _createVNode(_component_a_modal, {
    open: _ctx.dialogVisible,
    "onUpdate:open": _cache[4] || (_cache[4] = $event => _ctx.dialogVisible = $event),
    title: "更新说明",
    style: {
      "width": "550px"
    },
    onOk: _ctx.updateOk,
    cancelButtonProps: {
      style: {
        display: 'none'
      }
    },
    okButtonProps: {
      style: {
        backgroundColor: '#1677ff',
        borderColor: '#1677ff',
        fontSize: '12px',
        height: '25px',
        padding: '0 16px'
      }
    }
  }, {
    title: _withCtx(() => [_hoisted_19]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_a_tabs, {
      activeKey: _ctx.activeName,
      "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => _ctx.activeName = $event),
      class: "demo-tabs",
      onChange: _ctx.handleClick,
      "tab-position": "left"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateMsg, (item, index) => {
        return _openBlock(), _createBlock(_component_a_tab_pane, {
          key: item.vision,
          tab: item.vision
        }, {
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (x, index) => {
            return _openBlock(), _createElementBlock("li", {
              key: index
            }, _toDisplayString(x), 1);
          }), 128))]), _createVNode(_component_a_divider, {
            orientation: "right",
            style: {
              "font-size": "12px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.data), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["tab"]);
      }), 128))]),
      _: 1
    }, 8, ["activeKey", "onChange"])])]),
    _: 1
  }, 8, ["open", "onOk"])], 64);
}